(() => {
  if (window.NorelviReferenceContent) return;
  window.NorelviReferenceContent = true;
  let reviewsOpener;
  document.addEventListener('click', event => {
    const expand = event.target.closest('[data-proof-expand]');
    if (expand) {
      const opened = expand.getAttribute('aria-expanded') !== 'true';
      expand.setAttribute('aria-expanded', String(opened));
      expand.closest('.n-proof__card')?.classList.toggle('is-expanded', opened);
      expand.textContent = opened ? expand.dataset.less : expand.dataset.more;
      return;
    }
    const open = event.target.closest('[data-open-reviews],a[href="#norelvi-reviews"]');
    const modal = document.querySelector('[data-review-dialog]');
    if (open && modal?.showModal && modal.querySelector('n-reviews[data-ready="true"]')) {
      event.preventDefault();
      reviewsOpener = open;
      if (!modal.open) modal.showModal();
      modal.querySelector('[data-close-reviews]')?.focus();
    }
    if (event.target.closest('[data-close-reviews]')) modal?.close();
  });
  document.addEventListener('close', event => {
    if (event.target.matches('[data-review-dialog]') && reviewsOpener?.isConnected) reviewsOpener.focus({preventScroll:true});
  }, true);
})();
